import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';
import vuetify from './plugins/vuetify';
import VueHtmlToPaper from 'vue-html-to-paper';
import Vuelidate from 'vuelidate';
import * as VueMenu from '@hscmap/vue-menu';
import IdleVue from 'idle-vue';
// import axios from "axios";
import JsonExcel from 'vue-json-excel';
import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from "socket.io-client";

// const socket = io('http://localhost:8080');
const socket = io('http://localhost:8080');

Vue.use(VueSocketIOExt, socket);

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

Vue.config.productionTip = false;

Vue.component('downloadExcel', JsonExcel)
Vue.use(VueMenu)
Vue.use(Vuelidate)

const options = {
  name: 'table',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VueHtmlToPaper, options);
Vue.use(require('vue-moment'));
Vue.use(VeeValidate);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// var timeout = null;

// (async () => {
//   await axios.get('http://78.141.231.120:8080/api/general_settings')
//   .then(response => {
//     timeout = response.data[0].AccountLockoutDuration;
//     console.log("This is the response: ", timeout)
//   })
// })();

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 5000,
  startAtIdle: false
});

new Vue({
  router,
  store,
  mounted () {
    if(this.$store.state.auth.status.loggedIn){
      Promise.all([
        this.$store.dispatch('getAllApplicationDefaults'),
        this.$store.dispatch('getSystemDate'),
        this.$store.dispatch('getAllImages'),
        this.$store.dispatch('getAllActivations'),
        this.$store.dispatch('getAllBankAccountTypes'),
        this.$store.dispatch('getAllBankBranches'),
        this.$store.dispatch('getAllFundAccountTypes'),
        this.$store.dispatch('getAllOffices'),
        this.$store.dispatch('getAllNMIRebates'),
        this.$store.dispatch('getAllBanks'),
        this.$store.dispatch('getAllBondInvestmentTypes'),
        this.$store.dispatch('getAllCallAccountTypes'),
        this.$store.dispatch('getAllCountries'),
        this.$store.dispatch('getAllCities'),
        this.$store.dispatch('getAllClientTypes'),
        this.$store.dispatch('getAllCurrencies'),
        this.$store.dispatch('getAllDealerGroups'),
        this.$store.dispatch('getAllDeliveryMethods'),
        this.$store.dispatch('getAllDepositMethods'),
        this.$store.dispatch('getAllFinancialYears'),
        this.$store.dispatch('getAllFrequencies'),
        this.$store.dispatch('getAllHolidays'),
        this.$store.dispatch('getAllIdentityTypes'),
        this.$store.dispatch('getAllOverrideReasons'),
        this.$store.dispatch('getAllPropertyTypes'),
        this.$store.dispatch('getAllRejectionReasons'),
        this.$store.dispatch('getAllSectors'),
        this.$store.dispatch('getAllAccountStatuses'),
        this.$store.dispatch('getAllCustodianStatuses'),
        this.$store.dispatch('getAllPropertyStatuses'),
        this.$store.dispatch('getAllExchangePairs'),
        this.$store.dispatch('getAllTitles'),
        this.$store.dispatch('getAllTransactionCodes'),
        this.$store.dispatch('getAllPermissions'),
        this.$store.dispatch('getAllUsers'),
        this.$store.dispatch('getAllRoles'),
        this.$store.dispatch('getAllInvalidPasswords'),
        this.$store.dispatch('getSettings'),
        this.$store.dispatch('getAllInstrumentTypes'),
        this.$store.dispatch('getAllCounterpartyLimits'),
        this.$store.dispatch('getAllCounterparties'),
        this.$store.dispatch('getAllDealerLimits'),
        this.$store.dispatch('getAllTaxRates'),
        this.$store.dispatch('getAllTaxes'),
        this.$store.dispatch('getAllFees'),
        this.$store.dispatch('getAllMMRates'),
        this.$store.dispatch('getAllClients'),
        this.$store.dispatch('getAllClientAccounts'),
        this.$store.dispatch('getAllClientContacts'),
        this.$store.dispatch('getAllClientSignatories'),
        this.$store.dispatch('getAllApplicationModules'),
        this.$store.dispatch('getAllTransactionCharges'),
        this.$store.dispatch('getAllPeriods'),
        this.$store.dispatch('getAllBackdatingLimitPeriods'),
        this.$store.dispatch('getAllUnitsRounding'),
        this.$store.dispatch('getAllTransactions'),
        this.$store.dispatch('getAllPurchases'),
        this.$store.dispatch('getAllSales'),
        this.$store.dispatch('getAllReversals'),
        this.$store.dispatch('retrieveBonds'),
        this.$store.dispatch('retrieveProperties'),
        this.$store.dispatch('retrievePropertyValues'),
        this.$store.dispatch('retrieveDealers'),
        this.$store.dispatch('retrieveCounters'),
        this.$store.dispatch('retrieveUnlistedCounters'),
        this.$store.dispatch('getAllCustodians'),
        this.$store.dispatch('getAllKYCDocuments'),
        this.$store.dispatch('getAllComDocuments'),
        this.$store.dispatch('getAllDecDocuments'),
        this.$store.dispatch('getAllIndDocuments'),
        this.$store.dispatch('getAllParDocuments'),
        this.$store.dispatch('getAllPenDocuments'),
        this.$store.dispatch('getAllTruDocuments'),
        this.$store.dispatch('getAllRDCDocuments'),
        this.$store.dispatch('getAllPtlDocuments'),
        this.$store.dispatch('getAllMunDocuments'),
        this.$store.dispatch('getAllNGODocuments'),
        this.$store.dispatch('getAllCCODocuments'),
        this.$store.dispatch('getIdentity'),
        this.$store.dispatch('getAllEquities'),
        this.$store.dispatch('getAllTransactionchargerate'),
        this.$store.dispatch('getApplicationFunctions'),
        this.$store.dispatch('getStockExchanges'),
        this.$store.dispatch('getAllEventMappings'),
        this.$store.dispatch('getAllEvents'),
        this.$store.dispatch('getAllProfileTypes'),
        this.$store.dispatch('getAllEquityprices'),
        this.$store.dispatch('getAllUlEquities'),
        this.$store.dispatch('getAllUlEquityprices'),
        this.$store.dispatch('getAllAssetTransfersEquity'),
        this.$store.dispatch('retrieveDailyExchanges'),
        this.$store.dispatch('getAllCorpEvents'),
        this.$store.dispatch('retrieveConfirmationSettings'),
        this.$store.dispatch('retrieveUnitTrustFunds'),
        this.$store.dispatch('retrieveUnitTrustDeals'),
        this.$store.dispatch('retrieveUnitDistributions')
      ]).finally(() => {
        this.$root.$emit("Initialised")
      })
    }
  },
  vuetify,
  render: h => h(App)
}).$mount('#app');
